module.exports = __webpack_public_path__ + "46563bbac11507c1ced805c16d747eca.svg";